import {Component, OnInit, Input} from '@angular/core';
import {ControlContainer, FormBuilder} from '@angular/forms';

import {AppBaseComponent} from '@baseComponent';
import {MessageService, TrackingService, MasterService, ProcedureService} from '@services';

@Component({
  selector: 'app-validation-result',
  templateUrl: './validation-result.component.html',
  styleUrls: ['./validation-result.component.scss'],
})
export class ValidationResultComponent
  extends AppBaseComponent
  implements OnInit {
  listStatus: any[] = [];

  validationResultForm;
  statusName: any = [];
  @Input() title!: string;
  @Input() idTramite: any;
  @Input() isLegalPerson: boolean = false;
  @Input() tramiteObject: any;
  public statusId: any;
  public id: any;

  public concatenacionObservaciones: string;

  constructor(
    private procedureService: ProcedureService,
    private popupService: MessageService,
    public fb: FormBuilder,
    private controlContainer: ControlContainer,
    private trackingService: TrackingService,
    private masterService: MasterService
  ) {
    super();
  }

  ngOnInit(): void {
    this.validationResultForm = this.controlContainer.control;
    this.validationResultForm =
      this.validationResultForm.controls['resultValidationForm'];
    this.masterService
      .getStatus()
      .subscribe((resp) => {
        this.listStatus = resp;
        //filtra los estados del subdirector
        if (this.tramiteObject.statusId == 7) {
          this.listStatus = this.listStatus.filter(x => x.id == 10);
        } else if (this.tramiteObject.statusId == 11) {
          this.listStatus = this.listStatus.filter(x => x.id == 12);
        }
      });
    this.seguimiento(this.tramiteObject.id);
  }


  public mostrarIniciales(nombreCompleto): string {
    const partesNombre = nombreCompleto.split(" ");
    let iniciales: string = "";
    partesNombre.forEach(part => iniciales += part.charAt(0).toUpperCase());
    return iniciales;
  }

  public seguimiento(id: any): void {
    this.trackingService.getInfoSeguimiento(id).subscribe((values: any[]) => {
      this.statusName = values;

      if(values.length>0)
      {
        this.concatenacionObservaciones = values[values.length - 1].observation;
      }
      else {
        this.concatenacionObservaciones = "";
      }


    });
  }

  getErrorMessage(field: string): string {
    let message;
    switch (field) {
      case 'observation':
        if (
          this.validationResultForm?.get(field).hasError('required') &&
          this.isTouchedField(this.validationResultForm, field)
        ) {
          message = 'Es requerido';
        } else if (this.validationResultForm?.get(field).hasError('minlength') && this.isTouchedField(this.validationResultForm, field)) {
          message = `Debe tener al menos 5 caracteres`;
        }
        break;
      case 'statusId':
        if (
          this.validationResultForm?.get(field).hasError('required') &&
          this.isTouchedField(this.validationResultForm, field)
        ) {
          message = 'Es requerido';
        }
        break;
    }
    return message;
  }
}
